import { IMPROMPTU_MAX_ORIGINAL_UPLOAD_BYTES, IMPROMPTU_MAX_UPLOAD_BODY_BYTES } from "./config";
import { recordingBlobToPronunciationWav } from "./wav";

export class ImpromptuUploadError extends Error {
  constructor() {
    super("recording_too_large");
    this.name = "ImpromptuUploadError";
  }
}

/** Serialize once, measure the exact body, and send those same bytes with their boundary. */
export async function prepareImpromptuUpload(form: FormData, recording: Blob, filename: string) {
  const useServerConversion =
    process.env.NEXT_PUBLIC_IMPROMPTU_SERVER_CONVERSION_ENABLED !== "false";
  let audio = recording;
  let converted = false;
  if (!useServerConversion || recording.size > IMPROMPTU_MAX_ORIGINAL_UPLOAD_BYTES) {
    try {
      audio = await recordingBlobToPronunciationWav(recording);
      converted = true;
    } catch {
      throw new ImpromptuUploadError();
    }
  }
  const serialize = async () => {
    form.set(
      "audio",
      new File([audio], converted ? "impromptu-attempt.wav" : filename, {
        type: audio.type || "audio/webm",
      })
    );
    const encoded = new Response(form);
    const body = await encoded.blob();
    return { body, contentType: encoded.headers.get("content-type")!, converted };
  };
  let upload = await serialize();
  if (upload.body.size > IMPROMPTU_MAX_UPLOAD_BODY_BYTES && !converted) {
    try {
      audio = await recordingBlobToPronunciationWav(recording);
      converted = true;
    } catch {
      throw new ImpromptuUploadError();
    }
    upload = await serialize();
  }
  if (upload.body.size > IMPROMPTU_MAX_UPLOAD_BODY_BYTES) throw new ImpromptuUploadError();
  return upload;
}
